import { API_BASE_URL } from '../services/apiRegistry';

/**
 * Absolute URL for public API assets (tenant tournament logo, campaign banner, etc.).
 * Paths from the API look like `/api/public/...` — must NOT be prefixed with `API_BASE_URL`
 * (which already ends in `/api`) or the browser requests `/api/api/public/...` (404).
 */
export function publicAssetUrl(path) {
  if (!path) return '';
  const s = String(path).trim();
  if (!s) return '';
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) return s;
  const root = API_BASE_URL.replace(/\/?api\/?$/, '');
  return `${root}${s.startsWith('/') ? s : `/${s}`}`;
}

/** Origin only (no /api) — same root as publicAssetUrl. */
export function apiOrigin() {
  return API_BASE_URL.replace(/\/?api\/?$/, '');
}
